import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  X,
  Mail,
  Bold,
  Italic,
  Underline,
  List,
  ListOrdered,
  AlignLeft,
  AlignCenter,
  AlignRight,
  Type,
  Palette,
  Link2,
  Minus,
  Undo2,
  Redo2,
} from "lucide-react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";

const AddMailTemplate = ({ companies = [], user, close, editMail, mode }) => {
  const [company, setCompany] = useState(editMail?.company ?? "");
  const [templateId, setTemplateId] = useState(editMail?.templateId ?? "");
  const [serviceId, setServiceId] = useState(editMail?.serviceId ?? "");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!company) {
      MySwal.fire({ icon: "error", title: "Wypełnij", text: "Wybierz dział" });
      return;
    }
    if (!templateId.trim()) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "Wpisz ID szablonu",
      });
      return;
    }

    if (!serviceId.trim()) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "Wpisz ID serwisu",
      });
      return;
    }

    setSaving(true);
    try {
      var endpoint = mode === "edit" ? "/editMailTemplate" : "/addMailTemplate";
      const res = await fetch(`${API}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify({
          company,
          serviceId: serviceId,
          templateId: templateId,
          id: editMail?.id ?? "",
        }),
      });
      const data = await res.json();
      if (data.success) {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: `Konfiguracja została ${
            mode === "edit" ? "edytowana" : "dodana"
          }`,
        });
        close();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: data.message || "Nie udało się zapisać",
        });
      }
    } catch (err) {
      console.error(
        mode === "edit" ? "editMailTemplate:" : "addMailTemplate:",
        err
      );
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wystąpił błąd połączenia",
      });
    }
    setSaving(false);
  };

  const delMail = async () => {
    setSaving(true);
    try {
      var endpoint = "/deleteMail";
      const res = await fetch(`${API}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify({
          id: editMail?.id ?? "",
        }),
      });
      const data = await res.json();
      if (data.success) {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: `Szablon został usunięty`,
        });
        close();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: data.message || "Nie udało się usunąć",
        });
      }
    } catch (err) {
      console.error("delMail:", err);
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wystąpił błąd połączenia",
      });
    }
    setSaving(false);
  };

  return (
    <div
      className="sn-overlay"
      onClick={(e) => e.target === e.currentTarget && close()}
    >
      <div className="sn-modal" style={{ maxWidth: 720 }}>
        {/* Header */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Mail size={18} />
            <div>
              <h2 className="sn-title">Nowa konfiguracja e-mail</h2>
              <span className="sn-subtitle">Użytkownik: {user.name}</span>
            </div>
          </div>
          <button className="ld-close" onClick={close}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sn-body">
          {/* Dział */}
          <div
            className="db-filter-group"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <div style={{ width: "100%" }}>
              <p className="db-field-label">Dział</p>
              <select
                className="db-select"
                style={{ width: "100%" }}
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              >
                <option value="">-- Wybierz dział --</option>
                {companies.map((c) => (
                  <option key={c.id ?? c.name} value={c.name}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="db-filter-group">
            <label className="db-field-label">ID szablonu</label>
            <input
              type="text"
              className="db-input"
              placeholder="template_id"
              value={templateId}
              onChange={(e) => setTemplateId(e.target.value)}
            />
          </div>

          <div className="db-filter-group">
            <label className="db-field-label">ID serwisu</label>
            <input
              type="text"
              className="db-input"
              placeholder="service_id"
              value={serviceId}
              onChange={(e) => setServiceId(e.target.value)}
            />
          </div>

          <div className="scc-form-footer">
            <button className="lq-btn" onClick={close}>
              Anuluj
            </button>
            <button className="lq-btn" onClick={delMail}>
              Usuń
            </button>
            <button
              className="lq-btn lq-btn--success"
              onClick={handleSave}
              disabled={saving}
            >
              <Mail size={14} />{" "}
              {saving ? "Zapisywanie..." : "Zapisz konfigurację"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMailTemplate;
